import apiClient from './apiClient';

export interface QueryParams {
  companyFrom?: string;
  companyTo?: string;
  docFrom?: string;
  docTo?: string;
  payDateFrom?: string;
  payDateTo?: string;
  deptFrom?: string;
  deptTo?: string;
  salesFrom?: string;
  salesTo?: string;
  excludeZeroBalance?: boolean;
}

export interface WriteoffRow {
  FG06_01: string;
  FG06_02: string;
  FG06_03: string;
  FG06_12: string;
  FG06_13: number;
  FG06_14: string;
  FG06_141: string;
  FG06_15: number;
}

export interface ResultRow {
  FG05_01: string;
  FG05_02: string;
  FG05_11: string;
  FG05_12: number;
  FG05_13: number;
  FG05_41: number;
  payDate: string;
  balance: number;
  writeoffs: WriteoffRow[];
}

export interface QueryResponse {
  data: ResultRow[];
  count: number;
  message?: string;
}

export const pwg304Api = {
  async query(params: QueryParams): Promise<QueryResponse> {
    const res = await apiClient.post('/api/pwg304/query', params);
    return res.data;
  },
};
